import React from "react";
import DashBoardSideBar from "../../common/DashBoardSideBar";
import FooterDashBoard from "../../common/FooterDashBoard";
import Header from "../../common/Header";
import DashBoardSection from "./component/DashBoardSection";
import DashBoardHeader from "../../common/DashBoardHeader";
import ExternalScripts from "../../common/ExternalScripts";

const DashBoard = () => {
  return (
    <div className="boxcar-wrapper v2" >
      <ExternalScripts/>
          <DashBoardHeader dashBoardHeader={true} />
      <section className="dashboard-widget-two">
        <div className="right-box">
          <DashBoardSideBar />
          <DashBoardSection/>
        </div>
      </section>
      <FooterDashBoard />
    </div>
  );
};

export default DashBoard;
